const initialState = {
    agGridDefaultColDef: [],
    agGridRowData: [],
    agGridContextMenuItems: [],
    totalRowCount: -1,
    tableName: '',
    explorerViews: [],
    summaryAuditViews: [],
    virtualColumns: [],
    filesFromServer: [],
    filesFromContainer: [],
    eventMonitorId: [],
    spagGridDefaultColDef: [],
    agGridDefaultColDefHistory: [],
    spagGridRowData: [],
    spagGridContextMenuItems: [],
    sptotalRowCount: -1,
    spexplorerViews: [],
    sptableName: '',
    viewsignoffagGridDefaultColDef: [],
    viewsignoffagGridRowData: [],
    viewsignoffagGridContextMenuItems: [],
    viewsignofftotalRowCount: -1,
    viewsignoffexplorerViews: [],
    viewsignofftableName: '',
};

export default initialState;
